import { defineComponent as _defineComponent } from 'vue'
import { ProtestCategory } from "@/stores/protest-events";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelectMultipleItemsDialog',
  props: {
    value: null,
    items: null,
    maxValueLength: null,
    disabled: { type: Boolean },
    enableColor: { type: Boolean },
    label: null,
    disabledItem: null,
    enableNote: null
  },
  emits: ["input", "reset"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: ProtestCategory[]): void;
  (e: "reset"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: ProtestCategory[];
  items: ProtestCategory[];
  maxValueLength?: number;
  disabled?: boolean;
  enableColor: boolean;
  label: string;
  disabledItem?: ProtestCategory;
  enableNote?: string;
}




const isDialogVisible = ref<boolean>(false);
const selectedItems = ref<ProtestCategory[]>(props.value);
const selectedItem = ref<ProtestCategory>(
  props.disabledItem ? props.disabledItem : props.items[0]
);
const error = ref<string | undefined>();

watch(selectedItems, (newValue, oldValue) => {
  if (newValue.length === 0) {
    error.value = "Bitte wählen Sie mindestens 1 Element aus.";
    selectedItems.value = oldValue;
  }
  if (props.maxValueLength && props.maxValueLength > newValue.length) {
    error.value =
      "Bitte wählen Sie maximal " + props.maxValueLength + " Element aus.";
    selectedItems.value = oldValue;
  }
  emit("input", selectedItems.value);
});

watch(selectedItem, (newValue, oldValue) => {
  if (!newValue) {
    error.value = "Bitte wählen Sie mindestens 1 Element aus.";
    selectedItem.value = oldValue;
  }
  emit("input", [selectedItem.value]);
});

watch(
  () => props.value,
  () => {
    selectedItems.value = props.value;
  },
  { deep: true }
);

const deleteItem = (itemLabel: string) => {
  selectedItems.value = selectedItems.value.filter(
    (item) => item.label != itemLabel
  );
  emit("input", selectedItems.value);
};

return { __sfc: true,props, emit, isDialogVisible, selectedItems, selectedItem, error, deleteItem }
}

})